module.exports = __webpack_public_path__ + "static/mango-7333422aa03d0ac0ae69fd6ed157b3c3.jpg";